function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapshotblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon material-camera-alt"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 55",
    d: "M20.88 17.04a3.84 3.84 0 1 1-3.84-3.84 3.84 3.84 0 0 1 3.84 3.84z",
    transform: "translate(-5.04 -3.84)",
    style: {
      fill: "#204bf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 56",
    d: "M11.4 3 9.2 5.4H5.4A2.407 2.407 0 0 0 3 7.8v14.4a2.407 2.407 0 0 0 2.4 2.4h19.2a2.407 2.407 0 0 0 2.4-2.4V7.8a2.407 2.407 0 0 0-2.4-2.4h-3.8L18.6 3zM15 21a6 6 0 1 1 6-6 6 6 0 0 1-6 6z",
    style: {
      fill: "#204bf8"
    },
    transform: "translate(-3 -1.8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshotblue);
export default __webpack_public_path__ + "static/media/snapshotblue.d0b27640aafcc124942e41ff9ab63ea6.svg";
export { ForwardRef as ReactComponent };